import React from "react";
import { useApp } from "../contexts/AppContext";
import { paletteFromColor } from "./ClayCard";

// Site-wide action button. Inherits FORMAT, EFFECT and FONT from the Home
// buttons (Definições X) via AppContext.buttonStyle, while keeping its own color.
export default function SiteButton({
  color = "coral",
  onClick,
  type = "button",
  disabled = false,
  href,
  target,
  rel,
  download,
  icon: Icon,
  children,
  className = "",
  testId,
  size = "lg",
  fullWidth = true,
  format: formatOverride,
}) {
  const { buttonStyle } = useApp();
  const format = formatOverride || "flat";
  const effect = disabled ? "none" : (buttonStyle?.effect || "lift");
  const font = buttonStyle?.titleFont || "fredoka";
  const c = paletteFromColor(color);
  const style = { "--btn-bg": c.bg, "--btn-dark": c.dark, "--btn-text": c.text };
  const pad = size === "sm" ? "px-5 py-2.5 text-base" : "px-6 py-4 text-lg";
  const iconSize = size === "sm" ? 16 : 20;
  const cls = `home-btn fmt-${format} fx-${effect} ${pad} ${fullWidth ? "w-full" : "inline-block"} ${disabled ? "opacity-60 pointer-events-none" : ""} ${className}`;
  const widthStyle = fullWidth ? {} : { width: "auto" };
  const inner = (
    <span className={`relative z-[1] inline-flex w-full items-center justify-center gap-2 font-${font} font-bold leading-snug`}>
      {Icon && <Icon size={iconSize} strokeWidth={2.5} />}
      {children}
    </span>
  );
  if (href) {
    return (
      <a href={href} target={target} rel={rel} download={download} data-testid={testId} style={{ ...style, ...widthStyle, textAlign: "center", display: fullWidth ? "block" : "inline-block" }} className={cls}>
        {inner}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} disabled={disabled} data-testid={testId} style={{ ...style, ...widthStyle, textAlign: "center" }} className={cls}>
      {inner}
    </button>
  );
}
